import React from 'react'
import { render } from 'react-dom'

import { ExternalModalAdapter } from '../../Common/Components/Modal/ExternalModalAdapter'
import { CommonFormContextProvider } from '../../Common/Contexts/CommonFormContext'
import { SelfProvisioningModal } from '../Modal/SelfProvisioningModal'
import { $window } from '../../../NonReact/common/AkixiWindow'

/**
 * Adapter to create the Self Provisioning wizard modal.
 */
export default class SelfProvisioningAdapter extends ExternalModalAdapter {
    constructor() {
        super()

        $window.disableHotKeys = true

        render(
            <CommonFormContextProvider>
                <SelfProvisioningModal />
            </CommonFormContextProvider>,
            this.modalDiv
        )
    }

    public static newInstance(): SelfProvisioningAdapter {
        return new SelfProvisioningAdapter()
    }
}
